import { render, staticRenderFns } from "./visit-user.vue?vue&type=template&id=3135fd19&"
import script from "./visit-user.vue?vue&type=script&lang=js&"
export * from "./visit-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports